import { DialogContent } from "@mui/material";

export const MuiDialogContent = DialogContent;
